<template>
    <div class="form-group row m-b-sm operation-form">
        <operation-connect-with-modal v-if="typeName !== 'cash_register'"
            ref="modal"
            :action-type="actionType"
            :operation="operation"
            :method="method"
            :operationIndex="index"
            :groupName="groupName"
            :disabled="disabled"
            :helpName="help"
            @hideModal="modalHideHandler"
            @departmentTransferAccepted="notifyDepartmentTransferAccepted"
            @reloadOperations="reloadOperations"
            @contractorChanged="contractorChangeHandler(0, true)"
        />
        <operation-connect-with-in-cash-register-modal v-else
                                      ref="modal"
                                      :action-type="actionType"
                                      :operation="operation"
                                      :departments="departments"
                                      :operationIndex="index"
                                      :group="group"
                                      :method="method"
                                      :payment-source="paymentSource"
                                      @reloadOperations="reloadOperations"
                                      @setStorageData="setStorageData"
                                      :helpName="help"
                                      :has-access="hasAccess"
                                       :has-access-default="hasAccessDefault"
                                       :has-access-pl="hasAccessPl"
                                       :has-access-other-department="hasAccessOtherDepartment"
                                       :allow-invoice-for-bill-without-contractor="allowInvoiceForBillWithoutContractor"

        />
        <!-- N083 okienko identyczne jak na listach (imported_contractor_data_modal.blade.php) + Kopiuj -->
        <div
            v-if="operation.imported_contractor_data"
            ref="importedContractorDataModal"
            class="modal inmodal fade"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">{{ __('close') }}</span></button>
                        <h3>{{ __('imported_contractor_data') }}</h3>
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <tr><th style="width: 40%">{{ __('source_type_name') }}</th><td>{{ operation.imported_contractor_data.name }}</td></tr>
                            <tr><th>{{ __('additional_data') }}</th><td>{{ operation.imported_contractor_data.plus }}</td></tr>
                            <tr><th>{{ __('bank_account_number') }}</th><td>{{ operation.imported_contractor_data.nrb }}</td></tr>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-dismiss="modal">{{ __('close') }}</button>
                        <button type="button" class="btn btn-primary" @click="copyImportedContractorData">
                            <i class="fa fa-copy"></i> {{ __('copy') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-auto operation-date-column" :class="{ 'has-error': hasError(errorsKeys.date) }">
            <label>{{ __('date') }}*</label>
            <div class="input-group date">
                <datepicker
                    name="date"
                    id="date_id"
                    ref="datepicker"
                    :disabled="isDatePickerDisabled()"
                    :value="operation.date"
                    :options="datePickerOptions"
                    :setDatepickerDate="true"
                    :init-without-emit-event="true"
                    @input="dateChangeHandler"
                >
                </datepicker>
            </div>
            <span class="help-block text-danger" v-show="hasError(errorsKeys.date)">
                {{ hasError(errorsKeys.date) ? errors[errorsKeys.date][0] : '' }}
            </span>
        </div>
        <div class="col-md-1" :class="{ 'has-error': hasError(errorsKeys.amount) }">
            <input type="hidden" :value="updatedAt">
            <label class="text-right">{{ __('amount') }}* </label>
            <input
                v-model="typeName === 'cash_register' && this.operation.id < 0 ? null : operation.formatted_amount"
                type="text"
                name="amount"
                class="form-control money text-right"
                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                :disabled="((method === 'edit' && !isLastGroup && group.other_payments === 0) || typeName === 'cash_register') || disabled || departmentTransferAccepted || ((actionType === 'createGroup'|| actionType === 'editGroup'|| actionType === 'create' || actionType === 'edit') && operation.id > 0)"
                @keydown="preventNonNumbers($event)"
                @change="formattedAmountChangeHandler">
            <span class="help-block text-danger" v-show="hasError(errorsKeys.amount)">
                {{ hasError(errorsKeys.amount) ? errors[errorsKeys.amount][0] : '' }}
            </span>
        </div>
        <div class="col-md-3" :class="{ 'has-error': hasError(errorsKeys.contractor) }">
            <label>{{ __('contractor') }}</label>
            <div class="input-group">
                <div class="tooltip-wrapper col-md-11 nopadding">
                    <select2
                        v-model="operation.contractor_id"
                        class="s2-operation contractor_id m-l-xs nopadding"
                        name="contractor_id"
                        :id="groupName+String(index)"
                        :settings="{ width: '100%' }"
                        :options="contractorsList"
                        :disabled="(operation.id > 0 && !operation.not_recognised) || paymentSource.payment_type_name === 'cash_register'"
                        :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                        :readonly="disabled || departmentTransferAccepted"
                        @change="contractorChangeHandler"
                    >
                    </select2>
                </div>
                <div class="col-md-1 p-l-0 ml-0 d-flex align-items-center">
                    <button
                        v-if="canResetContractor"
                        type="button"
                        class="btn btn-danger btn-sm m-l-xs tooltip-more reset-contractor"
                        :data-toggle="'tooltip'"
                        :data-placement="'top'"
                        :data-original-title="__('reset_contractor')"
                        @click="resetContractor"
                    >
                        <i class="fa fa-times"></i>
                    </button>
                    <a
                        v-else-if="getPermission('adding_contractors') && !disabled && !departmentTransferAccepted && typeName !== 'cash_register' && this.operation.id < 0"
                        type="button"
                        class="btn btn-primary btn-sm m-l-xs tooltip-more contractor-add"
                        :href="addContractorsUrl + '&group_name='+groupNameToReturn"
                        :data-toggle="'tooltip'"
                        :data-placement="'top'"
                        :data-original-title="__('contractors_add')"
                        :readonly="disabled || departmentTransferAccepted"
                        @click="addContractor"
                    >
                        <i class="fa fa-plus"></i>
                    </a>
                    <a
                        v-if="operation.imported_contractor_data && typeName !== 'cash_register'"
                        href="#"
                        class="m-l-xs tooltip-more imported-contractor-data"
                        :data-toggle="'tooltip'"
                        :data-placement="'top'"
                        :data-original-title="__('imported_contractor_data')"
                        @click.prevent="showImportedContractorData"
                    >
                        <i class="fa fa-info-circle"></i>
                    </a>
                </div>
            </div>
            <span class="help-block text-danger" v-show="hasError(errorsKeys.contractor)">
                {{ hasError(errorsKeys.contractor) ? errors[errorsKeys.contractor][0] : '' }}
            </span>
        </div>
        <div class="col-md-3">
            <label>{{ __('by_title') }}</label>
            <div class="input-group">
                <div
                    class="tooltip-wrapper col-md nopadding " style="min-width: 0;"
                    :class="{ 'has-error': hasError(errorsKeys.left_for_split) }"
                    :data-toggle="method === 'show' ? 'tooltip' : ''"
                    :data-original-title="operation.title"
                >
                    <input
                        v-model="operation.title"
                        type="text"
                        class="form-control title operation-title tooltip-more"
                        readonly
                        name="title"
                        :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                        :data-mode="method"
                        :title="operation.title"
                        :readonly="true"
                        :data-toggle="'tooltip'"
                        :data-placement="'top'"
                        :data-original-title="operation.title">
                </div>
                <!-- N083 przyciski maja wlasna szerokosc - przy rozwinietym menu col-md-1 byla wezsza niz przycisk i przyciski nachodzily na siebie -->
                <div class="nopadding flex-shrink-0">
                    <button
                        type="button"
                        class="btn btn-primary btn-sm m-l-xs tooltip-more"
                        :data-operation-id="operation.id"
                        :data-toggle="'tooltip'"
                        :data-placement="'top'"
                        :data-original-title="__('connect_with')"
                        @click="showModal"
                    >
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
                <!-- kolumna zostaje także bez przycisku (niewidoczny przycisk) - pole Tytułem ma wtedy tę samą szerokość we wszystkich wierszach -->
                <div class="nopadding flex-shrink-0" v-if="showNotRecognisedColumn">
                    <button
                        v-if="!canLeaveNotRecognised"
                        type="button"
                        class="btn btn-danger btn-sm m-l-xs invisible"
                        tabindex="-1"
                        aria-hidden="true"
                        disabled
                    >
                        <i class="fa fa-times"></i>
                    </button>
                    <button
                        v-else
                        type="button"
                        class="btn btn-danger btn-sm m-l-xs tooltip-more leave-not-recognised"
                        :data-toggle="'tooltip'"
                        :data-placement="'top'"
                        :data-original-title="__('leave_not_recognised')"
                        @click="leaveNotRecognised"
                    >
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <span class="help-block text-danger" v-show="hasError(errorsKeys.left_for_split)">
                {{ hasError(errorsKeys.left_for_split) ? errors[errorsKeys.left_for_split][0] : '' }}
            </span>
        </div>
        <div class="col">
            <label style="text-transform : capitalize;">{{ __('description') }}</label>
            <input
                v-model="operation.description"
                type="text"
                class="form-control description"
                name="description"
                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                :readonly="disabled"
                @change="descriptionChangeHandler"
            >
        </div>
        <div class="col-md-1 balance_after_operation">
            <label class="white-space-no-wrap">{{ __('balance_after_operation_short') }}</label>
            <input
                v-model="operation.formatted_balance_after_operation"
                type="text"
                class="form-control money text-right"
                name="balance_after_operation"
                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                :readonly="true"
            >
        </div>
        <div class="col-md-auto table-icons text-right" v-show="!disabled">
            <label class="m-b"> </label>
            <a
                v-if="moveDownEnabled && !(actionType === 'create' && groupName === 'operations')"
                class="reorder arrow-down"
                :data-toggle="'tooltip'"
                :data-placement="'top'"
                :data-original-title="__('move_down')"
                @click="move(1)"
            >
                <i class="fas fa-arrow-down"></i>
            </a>
            <a
                class="reorder arrow-up" v-if="moveUpEnabled && !(actionType === 'create' && groupName === 'operations')"
                :data-toggle="'tooltip'"
                :data-placement="'top'"
                :data-original-title="__('move_up')"
                @click="move(-1)"
            >
                <i class="fas fa-arrow-up"></i>
            </a>
            <a
                v-if="(actionType === 'create' || group.other_payments === 1) && groupName === 'operations'"
                :data-toggle="'tooltip'"
                :data-placement="'top'"
                :data-original-title="__('move_to_others')"
                @click="moveToGroup('otherOperations')"
            >
                <i class="fas fa-arrow-circle-down"></i>
            </a>
            <a
                v-if="group.status !== 'closed'"
                :data-toggle="'tooltip'"
                :data-placement="'top'"
                :data-original-title="__('delete')"
                @click="deleteOperation"
            >
                <i class="fa fa-trash"></i>
            </a>
        </div>
    </div>
</template>

<script>
import actions from "../../vuex/action_types";
import filters from '../../services/Filters.js';
import store from '../../vuex/store';
import OperationConnectWithModal from "./OperationConnectWithModal";
import events from "../../services/Events";
import permissions from '../../services/Permissions.js';
import mutations from "../../vuex/payments/mutation_types";
import {Money} from '../../services/Money.js'
import axios from "axios";
import OperationConnectWithInCashRegisterModal from "./OperationConnectWithInCashRegisterModal";

export default {
    name: "OperationForm",
    components: {OperationConnectWithInCashRegisterModal, OperationConnectWithModal},
    props: {
        permissionAccess: [],
        operation: {
            type: Object,
            required: true,
            validator: function (operation) {
                let valid = true;
                ['contractor_id'].forEach(value => valid = operation.hasOwnProperty(value));
                return valid;
            }
        },
        moveDownEnabled:{
            type: Boolean,
            required: false,
            default: true,
        },
        moveUpEnabled:{
            type: Boolean,
            required: false,
            default: true,
        },
        departments:{
            type: Array,
            required: false,
        },
        groupNameToReturn:{
            type: String,
            required: false
        },
        typeName: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasAccess: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessDefault: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessPl: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessOtherDepartment: {
            type: Number,
            required: false,
            default: 0,
        },
        method: {
            type: String,
            required: false
        },
        actionType: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true,
        },
        dateTo: {
            required: false,
        },
        groupName: {
            required: false,
        },
        openModalOperationId: {
            type: String,
            required: false,
        },
        errors: {
            required: false,
            default: () => []
        },
        helpName: {
            type: String,
            default: null
        },
        updatedAt:{
            type: Number,
            required:true,
        },
        allowInvoiceForBillWithoutContractor: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data: function () {
        return {
            contractorId: this.operation.contractor_id,
            money: new Money(),
            formattedAmount: this.operation.formatted_amount,
            departmentTransferAccepted: false,
            help: this.localizedHelpName(),
        }
    },
    filters: filters,
    methods: {
        /**
         * N083 Prz Resetuj kontrahenta - alert, a po OK Oznaczenie operacji jako Nieodczytane.
         */
        resetContractor: function () {
            swal({
                    title: this.__('reset_contractor_alert'),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d9534f",
                    confirmButtonText: this.__('ok'),
                    cancelButtonText: this.__('cancel'),
                    closeOnConfirm: true
                },
                (result) => {
                    if (result) {
                        this.markAsNotRecognised();
                    }
                }
            );
        },
        /**
         * N083 Prz Pozostaw Nieodczytane.
         */
        leaveNotRecognised: function () {
            if (this.operation.id > 0) {
                this.markAsNotRecognised();
                return;
            }
            toggleLoader(true);
            this.$store.dispatch(actions.STORE_NOT_RECOGNISED_OPERATION, {
                action_type: this.actionType,
                created_operation: this.operation,
                current_url_to_block: $('#current-url-to-lock').val(),
                current_route_to_block: $('#current-route-to-lock').val(),
            }).then(response => {
                this.afterNotRecognised(response.data.operation, response.data.original_index);
            }).catch(error => this.notRecognisedFailed(error));
        },
        markAsNotRecognised: function () {
            toggleLoader(true);
            this.$store.dispatch(actions.MARK_OPERATION_NOT_RECOGNISED, this.operation.id)
                .then(response => this.afterNotRecognised(response.data.operation, this.operation.id))
                .catch(error => this.notRecognisedFailed(error));
        },
        afterNotRecognised: function (operation, originalIndex) {
            //przyciski Resetuj/Pozostaw znikają - bez tego zostaje ich tooltip
            $('.tooltip').remove();
            this.$store.commit(mutations.INIT_MODAL_CHECKBOXES, {
                'operationId': operation.id,
                'checkboxesCollection': {documents: [], departments: [], categories: [], transfers: [], source: []}
            });
            this.$store.commit(mutations.CLEAR_STATE_TO_COMMIT_ALLOCATIONS, {index: this.index, group_name: this.groupName});
            this.reloadOperations(operation.id, this.operation.id, operation.date, operation.title, null, originalIndex, operation);
            toggleLoader(false);
        },
        notRecognisedFailed: function (error) {
            toggleLoader(false);
            const notification = error.response && error.response.data ? error.response.data.notification : null;
            swal({
                    title: notification ? notification.message : this.__('error'),
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#d9534f",
                    confirmButtonText: this.__('close'),
                    closeOnConfirm: true
                },
            );
        },
        /**
         * N083 IK Zaimportowane dane kontrahenta + IK Kopiuj.
         */
        showImportedContractorData: function () {
            $(this.$refs.importedContractorDataModal).modal('show');
        },
        copyImportedContractorData: function () {
            const data = this.operation.imported_contractor_data;
            this.copyToClipboard([data.name, data.plus, data.nrb].map(value => value || '').join('\n'));
        },
        copyToClipboard: function (text) {
            const copied = () => toastr.success(this.__('copied_to_clipboard'));
            //navigator.clipboard dostępny tylko w bezpiecznym kontekście (https)
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(copied);
                return;
            }
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            if (document.execCommand('copy')) {
                copied();
            }
            document.body.removeChild(textarea);
        },
        setStorageData:function (){
            window.localStorage.setItem('groupName', this.groupName);
            window.localStorage.setItem('group_name', this.group.name)
            window.localStorage.setItem('group_date_to', this.group.date_to)
            window.localStorage.setItem('index', this.index);
            window.localStorage.setItem('operations', this.operations);
            window.localStorage.setItem('otherOperations', this.otherOperations);
            this.$emit('setStorageData')
        },
        getPermission: function(permission) {
            return permissions.getPermission(this.permissionAccess, permission);
        },
        isDatePickerDisabled: function (){
            return this.operation.is_connected_with_document && this.operation.payment_source.payment_type_name === 'cash_register';
        },
        showModal: function () {
            toggleLoader(true)
            $('.tooltip').tooltip('hide');
            const _this = this;
            axios.get('/records/payments/get-modal-content', {
                params: {'operation_id':_this.operation.id, 'payment_source':_this.paymentSource.id, 'contractor_id':_this.operation.contractor_id}
            })
                .then(response => {
                    _this.$refs.modal.dynamicContent = response.data.modalContext;
                    this.$refs.modal.loadModalData();
                    // this.$refs.modal.operationContractorTransfers = this.$refs.modal.prepareContractorTransfers()
                    _this.$refs.modal.modalVisible = true
                    toggleLoader(false)
                    setTimeout(() => {
                        $('.modal-dialog').draggable({
                            handle: ".modal-header"

                        });
                    }, 1000)

                })
                .catch(error => console.log(error.message))


        },
        isFullyLocated: function (){
          return this.operation.id < 0 ? true : this.operation.only_unallocated;
        },
        modalHideHandler: function () {
            this.$refs.modal.modalVisible = false
        },
        count: function (list) {
            return list.length;
        },
        move: function (direction) {
            this.$emit('move', {
                from: this.index,
                to: this.index + direction,
                group: this.groupName
            })
            this.clearTooltips();
        },
        clearTooltips: function () {
            $('.tooltip').tooltip('hide');
        },
        deleteOperation: function () {
            this.clearTooltips();
            const self = this;
            if (this.departmentTransferAccepted) {
                swal({
                        title: $.i18n._("cannot_delete_operation_in_different_department"),
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#d9534f",
                        confirmButtonText: $.i18n._("close"),
                        closeOnConfirm: true
                    },
                );
            } else {
                if (this.operation.id > 0) {
                    this.$store.dispatch(actions.PREVALIDATE_DELETE_OPERATION, {
                        'operation': this.operation
                    }).then(response => {
                        if (response.data.status !== undefined && response.data.status === 'success') {
                            swal({
                                    title: $.i18n._("delete_record_?"),
                                    text: response.data.message,
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#d9534f",
                                    cancelButtonText: "Anuluj",
                                    confirmButtonText: "Usuń",
                                }, function () {
                                self.$store.dispatch(actions.DELETE_OPERATION, {
                                    'operation': self.operation
                                }).then(response => {
                                    // self.$refs.modal.handleOperationDeleted();
                                    self.clearOperationState();
                                    self.$store.commit(mutations.DELETE_OPERATION, {
                                        'groupName': self.groupName,
                                        'index': self.index
                                    });
                                    self.$emit('amountHasChanged')
                                    toastr['success'](self.__(response.data.message)).css('border', '0px')
                                })
                            });
                        }
                        else{
                            swal({
                                    title: $.i18n._("warning_!"),
                                    text: response.data.message,
                                    type: "warning",
                                    confirmButtonColor: "#d9534f",
                                    cancelButtonText: "OK",
                                    closeOnConfirm: true
                                },
                            );
                        }
                    });

                } else {
                    this.clearOperationState();
                    this.$store.commit(mutations.DELETE_OPERATION, {
                        'groupName': this.groupName,
                        'index': this.index
                    });
                    this.$emit('amountHasChanged')
                }
            }
        },
        sortGroups: function () {
            store.commit(mutations.SORT_GROUPS);
        },
        clearOperationState: function () {
            this.$store.commit(mutations.CLEAR_STATE_TO_COMMIT_OPERATION, this.operationToCommit);
        },
        findOperationsToChangeLastIndex: function (changes) {
            const self = this;
            let amountNotZero = false;
            let lastOperationToChangeIndex = this.index;
            if (changes.group === 'operations') {
                this.operations.forEach((operation, index) => {
                    if (index > changes.index && self.money.toFloat(operation.formatted_amount) === 0 && !amountNotZero) {
                        lastOperationToChangeIndex = index;
                    }
                    if (index > changes.index && self.money.toFloat(operation.formatted_amount) !== 0) {
                        amountNotZero = true;
                    }
                })
            }
            return lastOperationToChangeIndex;
        },
        setDateValueWithoutChangeEvent: function (newDate) {
            this.$refs.datepicker.setStopChangeTriggerFlag(true);
            this.operation.date = newDate;
            this.$refs.datepicker.setStopChangeTriggerFlag(false);
        },
        dateChangeHandler: function (newDate) {
            this.operation.date = newDate;
            let lastIndex = this.index;
            if (this.group.other_payments !== 1) {
                lastIndex = this.findOperationsToChangeLastIndex({
                    group: this.groupName,
                    index: this.index
                })
            }
            if (this.actionType !== 'create' && this.group.other_payments === 0) {
                let operationDate = moment(this.operation.date)
                let groupDateTo = moment(this.dateTo)
                let groupDateFrom = moment(this.group.date_from)
                if(operationDate < groupDateFrom && this.groupName === 'operations'){
                    this.operation.date = this.group.date_from;
                    newDate = this.group.date_from;
                    this.$refs.datepicker.setValue(this.group.date_from);
                }
                if(operationDate > groupDateTo && this.groupName === 'operations' && this.group.status == 'closed'){
                    this.operation.date = this.group.date_to;
                    this.$refs.datepicker.setValue(this.group.date_to);
                    operationDate = moment(this.operation.date)
                }
                if (operationDate.isAfter(groupDateTo) && this.groupName === 'operations') {
                    this.clearOperationState();
                    this.$emit('checkNextOperations', {
                        newDate: newDate,
                        startIndex: this.index,
                        lastIndex: lastIndex,
                        useForms: false
                    })
                    store.commit(mutations.EXCHANGE_ELEMENTS, {
                        destinationGroup: 'otherOperations',
                        sourceIndex: this.operation.id,
                        lastIndex: lastIndex
                    });
                } else if (!operationDate.isAfter(groupDateTo) && this.groupName === 'otherOperations') {
                    this.clearOperationState();
                    store.commit(mutations.EXCHANGE_ELEMENTS, {
                        destinationGroup: 'operations',
                        sourceIndex: this.operation.id
                    });
                } else {
                    this.$store.commit(mutations.SET_STATE_TO_COMMIT_OPERATION, this.operationToCommit);
                    this.$emit('checkNextOperations', {
                        newDate: newDate,
                        startIndex: this.index,
                        lastIndex: lastIndex,
                        useForms: false
                    })
                }
            } else {
                let operationDate = moment(this.operation.date)
                let groupDateFrom = moment(this.group.date_from)
                if(operationDate < groupDateFrom ){
                    this.operation.date = this.group.date_from;
                    newDate = this.group.date_from;
                    this.$refs.datepicker.setValue(this.group.date_from);
                }
                this.$store.commit(mutations.SET_STATE_TO_COMMIT_OPERATION, this.operationToCommit);

            }
            this.sortGroups();
            this.$emit('amountHasChanged')
        },
        updateModalConfig: function (contractorId) {
            if (contractorId === 0) {
                this.$refs.modal.modalType = 'noContractor';
                this.$refs.modal.modalSize = 'lg';
                this.$refs.modal.colspan = 5;
            } else if (this.isContractorGlobal(contractorId)) {
                this.$refs.modal.modalType = 'globalContractor';
                this.$refs.modal.modalSize = 'md';
                this.$refs.modal.colspan = 4;
            } else {
                this.$refs.modal.modalType = 'localContractor';
                this.$refs.modal.modalSize = 'xl';
                this.$refs.modal.colspan = 6;
            }
            this.localizedHelpName(this.$refs.modal.modalType);
            ;
        },
        localizedHelpName: function (contractorType) {
            if (typeof this.$props.helpName === 'string' && this.$props.helpName.length > 0)
                return this.$props.helpName;
            if(this.typeName === 'cash_register'){
                this.help = 'EZQ-001'
                return 'EZQ-001';
            }
            switch (contractorType) {
                case 'globalContractor':
                    this.help = "EZM-001"
                    break;
                case 'localContractor':
                    this.help = "EZL-001";
                    break;
                default:
                    this.help = "EZN-001";
                    break;
            }
        },
        isContractorGlobal: function (contractorId) {
            let contractorsFiltered = this.contractorsList.filter(contractor => contractor.id === parseFloat(contractorId))
            if (contractorsFiltered.length === 0) {
                return false;
            } else {
                return contractorsFiltered[0].is_global;
            }
        },
        moveToGroup: function (groupName) {
            this.clearTooltips();
            this.$emit('moveToGroup', {
                sourceIndex: this.index,
                destinationGroup: groupName
            })
        },
        clearOperationStateAndStore: function () {
            // this.$emit('amountHasChanged')
            this.operation.formatted_amount = this.money.localize(this.money.toFloat(this.operation.formatted_amount));
            this.operation.generated_balance = null;
            this.$refs.modal.handleOperationDeleted();
            this.$refs.modal.loadClearModalData();
            this.$store.commit(mutations.SET_STATE_TO_COMMIT_OPERATION, this.operationToCommit);
            this.$refs.modal.sendToStore(true);


        },
        isOperationAmountChangeAlert: function () {
            return !['', undefined, null].includes(this.stateToCommit[this.groupName][this.index])
                && !['', undefined, null].includes(this.stateToCommit[this.groupName][this.index]['formatted_amount'])
                && this.stateToCommit[this.groupName][this.index]['formatted_amount'] !== this.operation.formatted_amount
                && this.money.toFloat(this.stateToCommit[this.groupName][this.index]['formatted_amount']) !== 0
                && this.stateToCommit[this.groupName][this.index]['left_for_split'] !== this.stateToCommit[this.groupName][this.index]['amount'];
        },
        isOperationContractorChangeAlert: function () {
            return !['', undefined, null].includes(this.stateToCommit[this.groupName][this.index])
                && !['', undefined, null].includes(this.stateToCommit[this.groupName][this.index]['formatted_amount'])
                && this.money.toFloat(this.operation.formatted_amount) !== 0
                && this.stateToCommit[this.groupName][this.index]['left_for_split'] !== this.stateToCommit[this.groupName][this.index]['amount'];
        },
        formattedAmountChangeHandler: function () {
            const self = this;
            if (this.isOperationAmountChangeAlert()) {
                swal({
                        title: $.i18n._("clear_allocation_?"),
                        text: $.i18n._("this_operation_has_been_allocated"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d9534f",
                        confirmButtonText: $.i18n._("delete"),
                        cancelButtonText: $.i18n._("cancel"),
                        closeOnConfirm: true
                    },
                    function (result) {
                        if (result) {
                            self.$refs.modal.updateTitle();
                            self.clearOperationStateAndStore();
                        } else {
                            self.operation.formatted_amount = self.stateToCommit[self.groupName][self.index].formatted_amount;
                        }
                    }
                );
            } else {
                this.clearOperationStateAndStore();
            }

            this.$emit('amountHasChanged')
            this.$refs.modal.updateTitle()
        },
        updateNewOperationAfterContractorChange: function (fromDifferentView = false) {
            if (!fromDifferentView) {
                this.$refs.modal.loadClearModalData();
            }
            this.$refs.modal.updateTitle();
            this.$store.commit(mutations.SET_STATE_TO_COMMIT_OPERATION, this.operationToCommit);
            this.$refs.modal.sendToStore(true);
            if (!fromDifferentView) {
                this.$store.commit(mutations.CLEAR_STATE_TO_COMMIT_ALLOCATIONS, {
                    index: this.index,
                    group_name: this.groupName
                });
            }
            this.$emit('amountHasChanged')
        },
        prepareDocumentsAndUpdate: function (response) {
            let allocatableDocuments = response.data;
            this.$store.commit(mutations.UPDATE_OPERATION, {
                'operation': {
                    'allocatable_documents': allocatableDocuments['data'],
                    'index': this.index
                },
                'groupName': this.groupName
            });
            this.updateNewOperationAfterContractorChange();
            toggleLoader(false)

        },
        changeContractorForNewOperation: function (changes, fromDifferentView = false) {
            const self = this;
            self.$store.commit(mutations.UPDATE_STATE_TO_COMMIT, changes);
            if (parseFloat(this.operation.contractor_id) !== 0) {
                // toggleLoader()
                // self.$store.dispatch(actions.PREPARE_DOCUMENTS, changes)
                //     .then(response => this.prepareDocumentsAndUpdate(response));
            } else {
                this.updateNewOperationAfterContractorChange(fromDifferentView);
            }

        },
        changeContractorForExistingOperation: function (changes) {
            const self = this;
            self.$store.commit(mutations.UPDATE_STATE_TO_COMMIT, changes);
            self.$store.dispatch(actions.REFRESH_GROUP_OPERATION, changes)
                .then(response => {
                    let operation = response.data;
                    operation.index = self.index;
                    operation.generated_balance = null;
                    self.$store.commit(mutations.UPDATE_OPERATION, {
                        'operation': operation,
                        'groupName': self.groupName
                    });
                    this.$refs.modal.updateTitle();

                    this.$store.commit(mutations.SET_STATE_TO_COMMIT_OPERATION, this.operationToCommit);
                    this.$refs.modal.sendToStore(true);
                    this.$store.commit(mutations.CLEAR_STATE_TO_COMMIT_ALLOCATIONS, {
                        index: this.index,
                        group_name: this.groupName
                    });
                    this.$emit('amountHasChanged')
                });
        },
        contractorChangeHandler: function (contractorId, fromDifferentView = false) {
            const self = this;
            let contractorIdFloat = parseFloat(contractorId);
            self.updateModalConfig(contractorIdFloat);
            let changes = {
                id: self.operation.id,
                payment_source_id: self.paymentSource.id,
                index: self.index,
                group_name: self.groupName,
                contractor_id: contractorIdFloat,
                date: self.operation.date,
                amount: this.money.toFloat(self.operation.formatted_amount),
                title: '',
            };
            if (self.operation.id > 0 && self.operation.not_recognised && !fromDifferentView) {
                //N083 operacja Nieodczytana nie ma połączeń do usunięcia, a Tytułem pozostaje bez zmian
                delete changes.title;
                self.changeContractorForExistingOperation(changes);
                self.$refs.modal.handleOperationDeleted();
                return;
            }
            if (self.isOperationContractorChangeAlert() && !fromDifferentView) {
                swal({
                        title: $.i18n._("clear_allocation_?"),
                        text: $.i18n._("this_operation_has_been_allocated"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d9534f",
                        confirmButtonText: $.i18n._("delete"),
                        cancelButtonText: $.i18n._("cancel"),
                        closeOnConfirm: true
                    },
                    function (result) {
                        if (result) {
                            self.changeContractorForExistingOperation(changes);
                            self.$refs.modal.handleOperationDeleted();
                        } else {
                            self.operation.contractor_id = self.stateToCommit[self.groupName][self.index].contractor_id;
                        }
                    }
                );
            } else {
                self.changeContractorForNewOperation(changes, fromDifferentView);
                self.$refs.modal.handleOperationDeleted();
            }
            this.$refs.modal.updateTitle()
        },
        descriptionChangeHandler: function () {
            this.$store.commit(mutations.SET_STATE_TO_COMMIT_OPERATION, this.operationToCommit);
            this.$refs.modal.sendToStore();
        },
        hasError: function (key) {
            return this.errors.hasOwnProperty(key)
                && Array.isArray(this.errors[key])
                && this.errors[key].length >= 1;
        },
        preventNonNumbers: function ($event) {
            let allowed = [
                'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0',
                'Comma', 'Minus',
                'Tab', 'Delete', 'Insert', 'ArrowLeft', 'ArrowRight', 'Escape', 'Backspace', 'F5', 'Enter',
                'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9',
                'NumpadComma', 'NumpadDecimal', 'NumpadSubtract', 'NumpadEnter'

            ];
            if (!allowed.includes($event.code)) {
                console.log($event.code);
                $event.preventDefault();
            }
        },
        getDateFrom: function () {
            if (this.actionType === 'create' || this.group.other_payments === 1) {
                if (!['', null, undefined].includes(this.lastGroup)) {
                    return moment(this.lastGroup.date_to).add(1, 'days').format('YYYY-MM-DD')
                } else {
                    return moment(this.paymentSource.for_day).add(1, 'days').format('YYYY-MM-DD')
                }
            } else {
                return this.group.date_from;
            }
        },
        getDateTo: function () {
            return this.group.other_payments === 1
            || this.actionType === 'create'
            || this.actionType === 'createGroup'
            || (this.isLastGroup && this.group.status != 'closed') ? null : this.group.date_to;
        },
        addContractor: function () {
            window.localStorage.setItem('groupName', this.groupName);
            window.localStorage.setItem('group_name', this.group.name)
            window.localStorage.setItem('group_date_to', this.group.date_to)
            window.localStorage.setItem('index', this.index);
            window.localStorage.setItem('operations', this.operations);
            window.localStorage.setItem('otherOperations', this.otherOperations);
        },
        notifyDepartmentTransferAccepted: function () {
            this.departmentTransferAccepted = true;
        },
        reloadOperations: function (id, index, date, title, source_transfer_amount = null, original_index = false, operation_object = null) {
            this.$emit('reloadOperations', id, index, date, title, source_transfer_amount, original_index, operation_object);
        },
        handleCorrectionDelete: function (correction, data, index) {
            if (correction.allocation_id === data.operationId) {
                this.$refs.modal.handlePaymentCorrectionDelete(index, false);
            }
        },
        handleCorrectionOffsetDelete: function (correction, data, index) {
            if (correction.operation_id === data.allocationId) {
                this.$refs.modal.handlePaymentCorrectionOffsetDelete(index, false);
            }
        },
        handleCurrencyExchangeDelete: function (correction, data, index) {
            if (correction.allocation_id === data.operationId) {
                this.$refs.modal.handleCurrencyExchangeDelete(index, false);
            }
        },
        handleCurrencyExchangeOffsetDelete: function (correction, data, index) {
            if (correction.operation_id === data.allocationId) {
                this.$refs.modal.handleCurrencyExchangeOffsetDelete(index, false);
            }
        },
        handleTransferPaymentCorrectionDelete: function (correction, data) {
            let contractorTransfer = this.$refs.modal.operationContractorTransfers.find(contractorTransfer => {
                return contractorTransfer.allocation_id === correction.operation_id;
            })
            let contractorTransferIndex = this.$refs.modal.operationContractorTransfers.indexOf(contractorTransfer);
            if (!['', null, undefined].includes(contractorTransfer) && correction.allocation_id === data.operationId) {
                this.$refs.modal.handleTransferPaymentCorrectionDelete(correction, contractorTransferIndex, false);
            }
        },
        handleTransferPaymentCorrectionOffsetDelete: function (correction, data) {
            let contractorTransfer = this.$refs.modal.operationContractorTransfers.find(contractorTransfer => {
                return contractorTransfer.allocation_id === correction.allocation_id;
            })
            let contractorTransferIndex = this.$refs.modal.operationContractorTransfers.indexOf(contractorTransfer);
            if (!['', null, undefined].includes(contractorTransfer) && correction.operation_id === data.allocationId) {
                this.$refs.modal.handleTransferCurrencyExchangeOffsetDelete(correction, contractorTransferIndex, false);
            }
        },
        handleTransferCurrencyExchangeDelete: function (correction, data) {
            let contractorTransfer = this.$refs.modal.operationContractorTransfers.find(contractorTransfer => {
                return contractorTransfer.allocation_id === correction.operation_id;
            })
            let contractorTransferIndex = this.$refs.modal.operationContractorTransfers.indexOf(contractorTransfer);
            if (!['', null, undefined].includes(contractorTransfer) && correction.allocation_id === data.operationId) {
                this.$refs.modal.handleTransferCurrencyExchangeDelete(correction, contractorTransferIndex, false);
            }
        },
        handleTransferCurrencyExchangeOffsetDelete: function (correction, data) {
            let contractorTransfer = this.$refs.modal.operationContractorTransfers.find(contractorTransfer => {
                return contractorTransfer.allocation_id === correction.allocation_id;
            })
            let contractorTransferIndex = this.$refs.modal.operationContractorTransfers.indexOf(contractorTransfer);
            if (!['', null, undefined].includes(contractorTransfer) && correction.operation_id === data.allocationId) {
                this.$refs.modal.handleTransferCurrencyExchangeOffsetDelete(correction, contractorTransferIndex, false);
            }
        },
        handleOtherPaymentDelete: function (data, correctionCollection, eventName) {
            if (![null, undefined, ''].includes(correctionCollection)) {
                correctionCollection.forEach((correction, index) => {
                    switch (eventName) {
                        case 'paymentCorrectionDeleted':
                            this.handleCorrectionOffsetDelete(correction, data, index);
                            break;
                        case 'paymentCorrectionOffsetDeleted':
                            this.handleCorrectionDelete(correction, data, index);
                            break;
                        case 'currencyExchangeDeleted':
                            this.handleCurrencyExchangeOffsetDelete(correction, data, index);
                            break;
                        case 'currencyExchangeOffsetDeleted':
                            this.handleCurrencyExchangeDelete(correction, data, index);
                            break;
                        case 'paymentCorrectionDeletedWithContractorTransfer':
                            this.handleTransferPaymentCorrectionOffsetDelete(correction, data);
                            break;
                        case 'paymentCorrectionOffsetDeletedWithContractorTransfer':
                            this.handleTransferPaymentCorrectionDelete(correction, data);
                            break;
                        case 'currencyExchangeDeletedWithContractorTransfer':
                            this.handleTransferCurrencyExchangeOffsetDelete(correction, data);
                            break;
                        case 'currencyExchangeOffsetDeletedWithContractorTransfer':
                            this.handleTransferCurrencyExchangeDelete(correction, data);
                            break;
                    }
                    // this.$refs.modal.updateTitle()
                });
            }
        }
    },
    watch: {
        index: function (val) {
            // this.$store.commit(mutations.UPDATE_STATE_TO_COMMIT, this.operationToCommit);
        },
        contractorsList: function (val){
            this.updateModalConfig(this.operation.contractor_id);
        }
    },
    computed: {
        //N083 widoczny dla operacji zapisanej i odczytanej
        canResetContractor: function () {
            return this.operation.id > 0 && !this.operation.not_recognised && !this.disabled
                && this.typeName !== 'cash_register' && this.method !== 'show';
        },
        showNotRecognisedColumn: function () {
            return !this.disabled && this.typeName !== 'cash_register' && this.method !== 'show';
        },
        //N083 widoczny dla operacji niezapisanej lub zapisanej jako odczytana
        canLeaveNotRecognised: function () {
            return !this.operation.not_recognised && !this.disabled && !this.departmentTransferAccepted
                && this.typeName !== 'cash_register' && this.method !== 'show';
        },

        operations: function () {
            return this.$store.getters.getOperations
        },
        otherOperations: function () {
            return this.$store.getters.getOtherOperations
        },
        contractorsData: function () {
            return this.$store.getters.getContractorsData
        },
        contractorsList: function () {
            if (this.$store.getters.getSource.currency_is_default && (this.$store.getters.getSource.currency.payment_type_name !== 'cash_register' && this.paymentSource.payment_type_name !== 'credit_card')) {
                return this.$store.getters.getSelect2ContractorsList
            } else {
                return this.$store.getters.getSelect2ContractorsList.filter(contractor => {
                    return !contractor.is_global;
                })
            }
        },
        paymentSource: function () {
            return this.$store.getters.getSource;
        },
        operationToCommit: function () {
            return {
                index: this.index,
                group_name: this.groupName,
                amount: this.money.toFloat(this.operation.formatted_amount),
                formatted_amount: this.operation.formatted_amount,
                contractor_id: this.operation.contractor_id,
                date: this.operation.date,
                id: this.operation.id,
                title: this.operation.title,
                description: this.operation.description,
                balance_after_operation: this.money.toFloat(this.operation.formatted_balance_after_operation),
                left_for_split: this.money.toFloat(this.$refs.modal !== undefined ? this.$refs.modal.leftForSplit: 0)
            }
        },
        operationId: function () {
            return this.operation.id
        },
        addContractorsUrl: function () {
            return this.$store.getters.getAddContractorsUrl
        },
        stateToCommit: function () {
            return this.$store.getters.getStateToCommit
        },
        group: function () {
            return this.$store.getters.getGroupData
        },
        lastGroup: function () {
            return this.$store.getters.getLastGroupData
        },
        isLastGroup: function () {
            return this.lastGroup !== null && this.lastGroup.id === this.group.id
        },
        datePickerOptions: function () {
            return {
                startView: 0,
                todayBtn: this.lastGroup === null || this.group.id === 0 || this.isLastGroup ? 'linked' : false,
                keyboardNavigation: false,
                forceParse: false,
                autoclose: true,
                format: "yyyy-mm-dd",
                todayHighlight: true,
                orientation: 'auto',
                disabled: this.disabled,
                startDate: this.getDateFrom(),
                endDate: this.getDateTo(),
            }
        },
        errorsKeys() {
            // these should match the rules keys from App\Http\Requests\OperationGroupFormRequest
            return {
                date: this.groupName + '.' + this.index + '.date',
                amount: this.groupName + '.' + this.index + '.formatted_amount',
                contractor: this.groupName + '.' + this.index + '.contractor_id',
                left_for_split: this.groupName + '.' + this.index + '.left_for_split'
            }
        },
    },
    mounted() {
        const self = this;
        this.updateModalConfig(this.operation.contractor_id);
        // this.$refs.modal.loadModalData(true)
        let modalVisible = this.openModalOperationId !== null && this.operation.id === parseFloat(this.openModalOperationId);
        if(modalVisible && this.operation.item_moved != true){
            toggleLoader()
            axios.get('/records/payments/get-modal-content', {
                params: {'operation_id':self.operation.id,'payment_source':self.paymentSource.id, 'contractor_id':self.operation.contractor_id}
            })
                .then(response => {
                    self.$refs.modal.dynamicContent = response.data.modalContext;
                    self.$refs.modal.loadModalData();
                    self.$refs.modal.modalVisible = modalVisible;
                    toggleLoader(false)
                })
                .catch(error => console.log(error.message))
        }

        events.$on('contractorAdded', function (data) {
            if (data.groupName === self.groupName && parseFloat(data.index) === self.index) {
                self.contractorChangeHandler(data.contractorId, true);
            }
        });

        // self.$store.commit(mutations.UPDATE_STATE_TO_COMMIT, self.operationToCommit);

        // events.$on('paymentCorrectionDeleted', function (data) {
        //     self.handleOtherPaymentDelete(data, self.$refs.modal.operationPaymentCorrectionsOffsets, 'paymentCorrectionDeleted');
        //     self.handleOtherPaymentDelete(data, self.$refs.modal.operationContractorTransfersCorrectionsOffsets, 'paymentCorrectionDeletedWithContractorTransfer');
        // });
        events.$on('paymentCorrectionOffsetDeleted', function (data) {
            self.handleOtherPaymentDelete(data, self.$refs.modal.operationPaymentCorrections, 'paymentCorrectionOffsetDeleted');
            self.handleOtherPaymentDelete(data, self.$refs.modal.operationContractorTransfersCorrections, 'paymentCorrectionOffsetDeletedWithContractorTransfer');
        });
        events.$on('currencyExchangeDeleted', function (data) {
            self.handleOtherPaymentDelete(data, self.$refs.modal.operationCurrencyExchanges, 'currencyExchangeDeleted');
            // self.handleOtherPaymentDelete(data, self.$refs.modal.operationContractorTransfersCurrencyExchanges, 'currencyExchangeDeletedWithContractorTransfer');
        });
        // events.$on('currencyExchangeOffsetDeleted', function (data) {
        //     self.handleOtherPaymentDelete(data, self.$refs.modal.operationCurrencyExchangesOffsets, 'currencyExchangeOffsetDeleted');
        //     self.handleOtherPaymentDelete(data, self.$refs.modal.operationContractorTransfersCurrencyExchangesOffsets, 'currencyExchangeOffsetDeletedWithContractorTransfer');
        // });
    },
    store
}
</script>

<style scoped>
/* N083 kolumna Data - szerokość samej daty */
.operation-date-column {
    max-width: 150px;
}
/* N083 IK Zaimportowane dane kontrahenta - kolor ikon aplikacji, wielkość zbliżona do przycisków obok */
.imported-contractor-data {
    color: #495966;
    font-size: 26px;
    line-height: 1;
}
</style>
